var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResetIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 9.37931C14 10.6888 13.6481 11.9688 12.9888 13.0576C12.3295 14.1463 11.3925 14.9949 10.2961 15.496C9.19975 15.9971 7.99335 16.1282 6.82946 15.8728C5.66557 15.6173 4.59648 14.9868 3.75736 14.0608C2.91825 13.1349 2.3468 11.9552 2.11529 10.6709C1.88378 9.38665 2.0026 8.05545 2.45673 6.84568C2.91085 5.63591 3.67989 4.6019 4.66658 3.87441C5.65328 3.14692 6.81331 2.75862 8 2.75862L11.1 2.75862L9.3 0.772414L10 0L13 3.31034L10 6.62069L9.3 5.84828L11.1 3.86207L8 3.86207C7.0111 3.86207 6.0444 4.18565 5.22215 4.79189C4.39991 5.39813 3.75904 6.25981 3.3806 7.26795C3.00217 8.2761 2.90315 9.38543 3.09608 10.4557C3.289 11.5259 3.76521 12.509 4.46447 13.2806C5.16373 14.0522 6.05465 14.5777 7.02455 14.7905C7.99445 15.0034 8.99979 14.8942 9.91342 14.4766C10.827 14.059 11.6079 13.3518 12.1573 12.4445C12.7068 11.5372 13 10.4705 13 9.37931H14Z",
    strokeWidth: 3,
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetIcon);
export default __webpack_public_path__ + "static/media/ResetIcon.44d3e4e231a96ce86a03a4957f680892.svg";
export { ForwardRef as ReactComponent };